<div class="tag" [ngClass]="{'selected': selected, 'disabled': disabled}">
  {{text}}
</div>
